
import md5 from './md5.js';

/**
* Triggers
*   na-extractedEntity.vidbaby
*	na-playSegment.vidaby
*	na-response.vidbaby
*   na-error.vidbaby
* Listening
*	na-ask.vidbaby
*   na-unPark.vidbaby
*   na-segmentEnded.vidbaby
*/

/*
to set the DF module use the following lines in the browser console
var data = {}
data.isCallback = false;
data.text = "<<start>>"
vidbaby.$(document).trigger('Send-to-dialogflow', [data]);

*/


function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	        var r = Math.random() * 16|0;
	        var v = (c == 'x') ? r : (r&0x3|0x8);
	        return v.toString(16);
	    });
}

function getSegmentName(data) {
	if(!data || !data.answer) return '';
	var maxPrefixLen = 20;
    var suffixLen = 8;
    var cleanText = data.answer.trim().toLowerCase();
	return cleanText.replace(/[^0-9a-z\s]/g, ' ').trim().replace(/\s+/g, '_').substr(0, maxPrefixLen) 
		+ '_' 
		+ md5(cleanText.replace(/\s+/g, ' ')).substr(0, suffixLen);
}

function normalizeDFObject(data) {
    let obj;
    switch (data.kind) {
        case 'structValue':
            obj = {};
            for(let i in data.structValue.fields)
                obj[i] = normalizeDFObject(data.structValue.fields[i]);
            break;
        case 'listValue':
            obj = data.listValue.values.map(v => normalizeDFObject(v));
            break;
        case 'stringValue':
            obj = data.stringValue;
            break;
        default:
            obj = data;
    }

    return obj;
}

var dialogFlow = {
    started: false,
    questionQueue: [],
    questionQueueRunning: false,
	sessionId: guid(),
    contexts: [],
    responseData: {}, //TODO fix, hack to get searches working
    
    init:  function (){
        vidbaby.$(document).on('na-ask.vidbaby', function(event, payload) {
            if(typeof payload === 'string') payload = { text: payload };
            if(typeof payload === 'object') {
                if(payload instanceof Array) {
                    payload.forEach(p => {
                        if(typeof p === 'string') p = { text: p };
                        dialogFlow.ask(p.text, p.isCallback);
                    });
                } else {
                    dialogFlow.ask(payload.text, payload.isCallback);
                }
            }
        });

        vidbaby.$(document).on('na-unPark.vidbaby', function(event, payload) {
            if(!dialogFlow.started) {
                //preload startup resources before this
                dialogFlow.ask('<<start>>', true);
            }
        });

        vidbaby.$(document).on('na-segmentEnded.vidbaby', function(event, payload) {
            dialogFlow.runQueue();
        });

        /*vidbaby.$(document).on('wrapper:convoStarted', function(event, payload) {
            dialogFlow.ask('<<start>>', true);
        });*/
    },
    setLoginContext(status) {
        if (status == '1') {
            dialogFlow.setContexts({
                name: `projects/${vidbaby.config.env.dialogFlowProject}/agent/sessions/${dialogFlow.sessionId}/contexts/loggedin`,
                lifespanCount: 99
            });
            dialogFlow.setContexts({
                name: `projects/${vidbaby.config.env.dialogFlowProject}/agent/sessions/${dialogFlow.sessionId}/contexts/loggedout`,
                lifespanCount: 0
            });
        }else{
            dialogFlow.setContexts({
                name: `projects/${vidbaby.config.env.dialogFlowProject}/agent/sessions/${dialogFlow.sessionId}/contexts/loggedin`,
                lifespanCount: 0
            });
            dialogFlow.setContexts({
                name: `projects/${vidbaby.config.env.dialogFlowProject}/agent/sessions/${dialogFlow.sessionId}/contexts/loggedout`,
                lifespanCount: 99
            });

        }
    },
    setContexts(contexts) {
        //https://cloud.google.com/dialogflow/docs/contexts-manage#api
        let map = {};
        dialogFlow.contexts.concat(contexts).forEach(context => {
            map[context.name] = context.lifespanCount;
        });
        dialogFlow.contexts = [];
        for(var name in map) {
            dialogFlow.contexts.push({ name, lifespanCount: map[name] });
        }
    },
    runQueue() {
        if(!this.questionQueue.length || this.questionQueueRunning) return;
        let params = this.questionQueue.shift();
        if(!params.question) return;
        let question = params.question;
        let callback = params.callback;
        dialogFlow.started = true;
        this.questionQueueRunning = true;
        var req = vidbaby.$.ajax({
            type: 'POST',
            url: 'https://' + vidbaby.config.env.bridge + '/' + vidbaby.config.env.dialogFlowEndpoint,
            data: JSON.stringify({
                projectId: vidbaby.config.env.dialogFlowProject,
                sessionId: dialogFlow.sessionId,
                query: question,
                queryParams: { contexts:this.contexts }
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).then(data => {
            //change state before video starts so that the avatar can be interrupted by a new question
            this.questionQueueRunning = false;
            dialogFlow.handleResponse(data, req.cbIgnore);
        }).fail(error => {
            this.questionQueueRunning = false;
            vidbaby.$(document).trigger('na-error.vidbaby', { question, error });
            console.log('na-error', { question, error });
            this.runQueue();
        });
        vidbaby.$(document).trigger('na-question.vidbaby', {question:question,isCallback:callback});
        //if(vidbaby.isParked && typeof vidbaby.unPark === 'function') vidbaby.unPark();
    },
	ask: function (question, callback) {
        this.questionQueue = this.questionQueue.filter(c => {
            return (c.callback) ? true : false;
        });
        this.questionQueue.push({ question, callback });
        this.runQueue();
	},
	handleResponse: function (data, cbIgnore) {
        dialogFlow.responseData = data;
        let answer = (data.answer && data.answer !== '""') ? data.answer : '';
		var triggerData = {
            text: answer,
    		answer: answer,
    		answerText: answer,
    		displayPageUrl: null,
    		clickableResponses: [],
    		customView: null
    	};
        if(data.parameters && data.parameters.fields) {
            for(let i in data.parameters.fields) {
                //will not run if fields are empty
                vidbaby.$(document).trigger('na-extractedEntity.vidbaby', {
                    [i]: normalizeDFObject(data.parameters.fields[i])
                });
            }
        }

    	data.rawResponse.fulfillmentMessages.forEach(fulfillmentMessage => {
    		if (fulfillmentMessage.message == 'payload' && typeof fulfillmentMessage.payload != 'undefined' && typeof fulfillmentMessage.payload.fields != 'undefined') {
    			//clickable responses
    			if(typeof fulfillmentMessage.payload.fields.clickableResponses != 'undefined') {
    				triggerData.clickableResponses = triggerData.clickableResponses.concat(fulfillmentMessage.payload.fields.clickableResponses.listValue.values.map(v => v.stringValue));
    			}

                if(typeof fulfillmentMessage.payload.fields.clientData != 'undefined' && typeof fulfillmentMessage.payload.fields.clientData.structValue.fields != 'undefined') {
        			//display page url
        			if(typeof fulfillmentMessage.payload.fields.clientData.structValue.fields.displayPageUrl != 'undefined') {
        				triggerData.displayPageUrl = fulfillmentMessage.payload.fields.clientData.structValue.fields.displayPageUrl.stringValue;
        			}
        			//custom view
        			if(typeof fulfillmentMessage.payload.fields.clientData.structValue.fields.customView != 'undefined') {
        				triggerData.customView = fulfillmentMessage.payload.fields.clientData.structValue.fields.customView.stringValue;
        			}
                    
                    //searchForQueryText TODO fix, Hack fix to get this working again
                    if(typeof fulfillmentMessage.payload.fields.clientData.structValue.fields.searchForQueryText != 'undefined' && fulfillmentMessage.payload.fields.clientData.structValue.fields.searchForQueryText.boolValue == true) {
                        if (typeof dialogFlow.responseData.parameters.fields.searchTerm != 'undefined'){
                            searchFor(dialogFlow.responseData.parameters.fields.searchTerm.listValue.values[0].stringValue);
                        }else{
                            searchFor(dialogFlow.responseData.rawResponse.queryText);
                        }
                        //$searchTerm
        				//triggerData.searchForQueryText = fulfillmentMessage.payload.fields.clientData.structValue.fields.searchForQueryText.stringValue;
        			}
                    
                }
                //client callbacks
                if(typeof fulfillmentMessage.payload.fields.clientCallBack != 'undefined') {
                    dialogFlow.questionQueue.push({
                        question: fulfillmentMessage.payload.fields.clientCallBack.stringValue,
                        callback: true
                    });
                }
    		}
    	});

    	vidbaby.$(document).trigger('na-response.vidbaby', triggerData);

        if(data.answer && data.answer != '""' && !cbIgnore) {
            vidbaby.$(document).trigger('na-playSegment.vidbaby', getSegmentName(data));
        } else if(dialogFlow.clientCallBack && !cbIgnore) {
            dialogFlow.ask(dialogFlow.clientCallBack, true);
        }
	},
};

export default dialogFlow;